import React, { useEffect } from 'react';
import {sendEventToGA} from "./../../utils.js";
import {CDAWebDataFileTypes, CDAWebAudioFileTypes} from './../../constants.js';
import {CdaWebModalDownloadDropdownButton} from './cdawebmodaldownloaddropdownbutton.js';

/**
 * Modal buttons that deal with actions/request that can be made to CDAWeb for a given dataset.
 *
 * @param props.startTime Datetime string that indicates the start time of interest.
 * @param props.stopTime Datetime string that indicates the stop time of interest.
 * @param prop.onGetDataFromCDAWeb Function that will make requests to CDAWeb server.
 * @param props.loading Boolean that indicates status of request of server.
 * @param props.displayLoading  Function that performs actions while data is loading
 * @param props.addOptions Function that keeps track of options associated with available actions (for example 'plot action')
 * @return JSX
 */
export function CdaWebModalButtonsRow(props) {
    const {startTime, stopTime, title, onGetDataFromCDAWeb, handleError, loading, displayLoading, addOptions} = props;
    const plotOptions = [
                         {label:'Coarse Noise Filtering', queryId: 'nonoise'},
                         {label:'Change the Y-axis width', queryId: 'bigplot'},
                         {label:'Higher Resolution', queryId: 'highres'},];


    const buttons = [
      { id: 1, text: 'Download Audio Files', action: onGetDataFromCDAWeb, options: [{}]},
      { id: 2, text: 'Download Data Files', action: onGetDataFromCDAWeb, options: [] },
      { id: 3, text: 'Plot Data', action: onGetDataFromCDAWeb, options: plotOptions, jsxElements:""}
    ];


    useEffect(() => {
        addOptions([{group: 'Plot', options: buttons[2].options}]);
        // eslint-disable-next-line
    }, [])


    const handleClick = (button, startTime, stopTime) => {

        if(startTime === '' || stopTime === '')
        {
            handleError({status:"004"});
            return;
        }

        if(stopTime <= startTime) {
            handleError({status:"005"});
            return;
        }

        displayLoading();

        if (button.action) {
            sendEventToGA(`dataset_access__cdaweb_modal__${button?.text?.replace(" ", "_")}__button`, title);
            button.action();
        }
    };


    return (
        <div className="cdaWebModalButtonRow">
          {buttons.map((el, index) => (
            el.id === 3
            ?
            (<div className="cdaWebModalButtonAndOptions" key={index}>
              <button key={index}
                      className={`${"cdaWebModalPlotButton"}`}
                      onClick={()=>handleClick(el, startTime, stopTime)}
                      disabled={loading} >{loading ?
                        <div>
                          <div className="cdaWebModalButtonSpinner"></div>
                        </div> : el.text}</button>
            </div>)
            :
            <CdaWebModalDownloadDropdownButton
              options = {el.id === 2 ? CDAWebDataFileTypes : CDAWebAudioFileTypes}
              button  = {el}
              key={index}
              loading = {loading}
              displayLoading= {displayLoading}
              prefix = "Download as" />
          ))}
        </div>
    );
}
